import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clamp as e } from "../../core/mathUtils.js";
import { classes as t } from "./widgetUtils.js";
import "../../core/has.js";
import "../../core/Logger.js";
import { tsx as o } from "./jsxFactory.js";
var r = {
  heading: "esri-widget__heading"
};

function s(s, i) {
  var c = "h".concat(e(Math.ceil(s.level), 1, 6));
  return delete s.level, o(c, _objectSpread(_objectSpread({}, s), {}, {
    class: t(r.heading, s.class)
  }), i);
}

export { r as CSS, s as Heading };